/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConfirmOTPLoginDataParser = /* #__PURE__ */ parsers.object([
    ['code', codecString],
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class ConfirmOTPLoginData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConfirmOTPLoginDataParser.decode(input).map(res => new ConfirmOTPLoginData(res));
    }
    static unsafeDecode(input) {
        return ConfirmOTPLoginData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmOTPLoginDataParser.encode(data);
    }
    static schema() {
        return ConfirmOTPLoginDataParser.schema();
    }
}
